import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import cs from 'classnames';
import styles from './style/index.module.less';
const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0';
// const APP_ENV = process.env.SYSTEM_ENVIRONMENT || 'Dev';

function Footer(props = {}) {
  const {
    className,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(_Layout.Footer, _extends({
    className: cs(styles.footer, className)
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: styles['footer-content']
  }, /*#__PURE__*/React.createElement("span", null, "Tobiz Account"), /*#__PURE__*/React.createElement("span", {
    className: styles['footer-version']
  }, "v", APP_VERSION)));
}
export default Footer;